// extracted by mini-css-extract-plugin
module.exports = {"background":"NavBar_background__48-D5","navBar":"NavBar_navBar__2ek9w","logoImg":"NavBar_logoImg__1Fktt","botNav":"NavBar_botNav__2ZI8G"};